export default {
    parentPadding: {
        padding: "40px 40px 27px 40px"
    },

    cardTitle: {
        margin: "0px 0px 4px 0px"
    },

    cardButton: {
        border: "none",
        outline: "none",
        backgroundColor: "inherit",
        color: "#215DAA",
        display: "inline-block",
        padding: "0px"
    },

    needHelpLabel: {
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "18px",
        color: "#262626",
        cursor: "pointer"
    },

    bottomIcon: {
        position: "absolute",
        bottom: "0px",
        right: "0px"
    }
};
